/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/specialHandler/highFrame.ts
 * @Author: Yongchao Wang
 * @Date: 2021-11-25 13:33:38
 * @LastEditors: Yongchao Wang
 * @LastEditTime: 2022-01-12 14:04:04
 * @Description: version 2.0 高柜渲染逻辑
 */
import MeshManage from '../meshManage';
import { FRAMECATEGORY, SKIRTINGBOARDCONFIG } from '../utils/kitchenConfig';
// import { FRAMECATEGORY } from '../utils/kitchenConfig';
class HightFrame {
    constructor(frame, scene) {
        this.frame = frame;
        this.scene = scene;
        this.position = this.scene.getMeshByName(frame.componentBasic.id).position;
    }
    static checkEmptyPlaceholderHighFrame(frame) {
        if (frame.doors) {
            return false;
        }
        return true;
    }
    /**
    * @description: 重新渲染高柜的配件（包括门板把手）
    * @param {any} changeMap 改变的新老高柜信息
    * @param {RenderBaseType} typeRenderEngine 渲染器
    * @return {*}
    * @author: Yongchao Wang
    */
    reRenderHighFrameAccessories(changeMap, typeRenderEngine, location) {
        // 重置高柜
        this.resetHighFrame(typeRenderEngine.rotationMeshes);
        console.log(location);
        // 替换门板
        this.resetHighFrameAccessories(changeMap, typeRenderEngine.rotationMeshes);
        // 重新组合门板
        typeRenderEngine.groupMeshsHighFrameDoors(this.frame, this.frame.doors, location);
        // 摆放高柜
        this.putHighFrame(typeRenderEngine.rotationMeshes);
    }
    // 重置高柜到初始位置
    resetHighFrame(rotationMeshes) {
        const highFrameId = this.frame.componentBasic.id;
        const rotation = rotationMeshes[highFrameId];
        const highFrameMeshManage = new MeshManage(this.scene.getMeshByName(highFrameId));
        this.position = highFrameMeshManage.getPosition();
        highFrameMeshManage.setModelPosition({ x: 0, y: this.position.y, z: 0 });
        if (rotation) {
            highFrameMeshManage.addRotation(-rotation.x, -rotation.y, -rotation.z);
        }
    }
    // 摆放旋转高柜到原来位置
    putHighFrame(rotationMeshes) {
        const highFrameId = this.frame.componentBasic.id;
        const rotation = rotationMeshes[highFrameId];
        const highFrameMeshManage = new MeshManage(this.scene.getMeshByName(highFrameId));
        if (rotation) {
            highFrameMeshManage.addRotation(rotation.x, rotation.y, rotation.z);
        }
        highFrameMeshManage.setModelPosition(this.position);
    }
    /**
     * @description: 重置高柜配件的位置,把老的门板remove，新的添加到高柜上
     * @param {any} changeMap 改变的新老高柜信息
     * @param {any} rotationMeshes 选择角度和mesh的合集
     * @return {*}
     * @author: Yongchao Wang
     */
    resetHighFrameAccessories(changeMap, rotationMeshes) {
        const positions = [];
        const parents = [];
        //  const tempRotationMeshes = rotationMeshes;
        if (changeMap.old) {
            changeMap.old.forEach((element) => {
                if (!element.componentBasic.show || !element.componentBasic.modelUrl) {
                    positions.push(undefined);
                    parents.push(undefined);
                    return;
                }
                const child = this.scene.getMeshByName(element.componentBasic.id);
                if (!child) {
                    console.error(element.componentBasic.id);
                    return;
                }
                const { parent, position } = child;
                parent === null || parent === void 0 ? void 0 : parent.removeChild(child);
                child.dispose();
                this.scene.removeMesh(child);
                positions.push(position);
                parents.push(parent);
            });
        }
        if (changeMap.new) {
            changeMap.new.forEach((element, index) => {
                if (!element.componentBasic.show || !element.componentBasic.modelUrl) {
                    return;
                }
                const child = this.scene.getMeshByName(element.componentBasic.id);
                const oldElementId = changeMap.old[index].componentBasic.id;
                const rotation = rotationMeshes[oldElementId];
                if (rotation) {
                    //  child.addRotation(rotation.x, rotation.y, rotation.z);
                    //  tempRotationMeshes[element.componentBasic.id] = rotation;
                }
                const parent = parents[index >= parents.length - 1 ? index - 1 : index];
                const position = positions[index];
                child.position.x = position.x;
                child.position.y = SKIRTINGBOARDCONFIG.HEIGHT;
                child.position.z = position.z;
                const parentRotation = rotationMeshes[parent === null || parent === void 0 ? void 0 : parent.name];
                if (parentRotation) {
                    //  child?.addRotation(parentRotation.x, parentRotation.y, parentRotation.z);
                    //  tempRotationMeshes[parent.name] = parentRotation;
                }
                parent === null || parent === void 0 ? void 0 : parent.addChild(child);
            });
        }
    }
    /**
    * @description: 检查柜子是否是高柜
    * @param {*} frames
    * @param {*} index
    * @return {*}
    * @author: Yongchao Wang
    */
    static checkFrameIsHighFrame(frame) {
        if (!frame) {
            return false;
        }
        if (frame.categoryId === FRAMECATEGORY.CATEGORY_10
            || frame.categoryId === FRAMECATEGORY.CATEGORY_11
            || frame.categoryId === FRAMECATEGORY.CATEGORY_12
            || frame.categoryId === FRAMECATEGORY.CATEGORY_33
            || frame.categoryId === FRAMECATEGORY.CATEGORY_34
            || frame.categoryId === FRAMECATEGORY.CATEGORY_35
            || frame.categoryId === FRAMECATEGORY.CATEGORY_36
            || frame.categoryId === FRAMECATEGORY.CATEGORY_37) {
            return true;
        }
        return false;
    }
}
export default HightFrame;
